import { connect } from 'react-redux'
import { dateAdjustedForTimezone } from '@opallabs/lambda'
import { jsonApiWrapper, EntityNames } from '@opallabs/wormhole'
import Row from '.'

export const mapStateToProps = (state, props) => {
  if (!props.entityType || props.entityType === 'group') return {}
  if (!state.jsonApiEntities) return {}

  const wrappedEntity = jsonApiWrapper({
    data:
      state.jsonApiEntities[props.entityType] &&
      state.jsonApiEntities[props.entityType][props.entityId],
    state,
  })

  if (!wrappedEntity) return {}

  switch (props.entityType) {
    case EntityNames.service.singular:
      return {
        serviceName: wrappedEntity.system_name,
        serviceColor: wrappedEntity.color,
      }
    case EntityNames.moment.singular: {
      // Get the moment's approval status from its content
      let momentContent = Object.values(state.jsonApiEntities.content)
      momentContent = momentContent.filter(
        (content) => content.relationships.moment.id === props.entityId
      )
      const approvalStatuses = momentContent.map((content) => content.status)

      return {
        approvalStatuses,
        budgetId: wrappedEntity.budget && wrappedEntity.budget.id,
        budget: wrappedEntity.budget && wrappedEntity.budget.value,
        endDate: dateAdjustedForTimezone(wrappedEntity.scheduled_end_at),
        name: wrappedEntity.name,
        startDate: dateAdjustedForTimezone(wrappedEntity.scheduled_at),
      }
    }
    case EntityNames.content.singular:
      return {
        approvalStatus: wrappedEntity.status,
        startDate: dateAdjustedForTimezone(wrappedEntity.scheduled_at),
        endDate: dateAdjustedForTimezone(wrappedEntity.takedown_scheduled_at),
        liveUrl: wrappedEntity.live_url,
        name: wrappedEntity.name || wrappedEntity.title,
        serviceAssetReference:
          wrappedEntity.service && wrappedEntity.service.asset_reference,
        serviceId: wrappedEntity.service && wrappedEntity.service.id,
        serviceColor: wrappedEntity.service && wrappedEntity.service.color,
        serviceIconName:
          wrappedEntity.service && wrappedEntity.service.icon_name,
        serviceName: wrappedEntity.service && wrappedEntity.service.system_name,
        budgetId: wrappedEntity.budget && wrappedEntity.budget.id,
        dispatchProviderAccountId:
          wrappedEntity.account &&
          wrappedEntity.account.dispatch_provider_account &&
          wrappedEntity.account.dispatch_provider_account.id,
        accountName: wrappedEntity.account ? wrappedEntity.account.name : '',
        accountId: wrappedEntity.account ? wrappedEntity.account.id : '',
        budget: wrappedEntity.budget && wrappedEntity.budget.value,
        placementName: wrappedEntity.placement && wrappedEntity.placement.name,
        placements:
          wrappedEntity.account && wrappedEntity.account.placements
            ? wrappedEntity.account.placements
            : [],
      }
    case EntityNames.story.singular:
      return {
        budgetId: wrappedEntity.budget && wrappedEntity.budget.id,
        startDate: wrappedEntity.scheduled_start_at,
        endDate: wrappedEntity.scheduled_end_at,
        name: wrappedEntity.name,
      }
    default:
      return {}
  }
}

const ConnectedRow = connect(mapStateToProps)(Row)

export default ConnectedRow
